module.exports = __webpack_public_path__ + "static/media/no-tier-person.aca2d156.svg";